import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home";
import PlantHealth from "./components/planthealth";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { PlantDiseaseDetection } from "./components/PlantDiseaseDetection";
import StrawberryPrediction from "./components/StrawberryPrediction";
import { FertilizerReport } from "./components/FertilizerReport";
import { WaterReport } from "./components/WaterReport";
import { AboutProject } from "./components/AboutProject";
import MangoPrediction from "./components/MangoPrediction";
import PotatoPrediction from "./components/PotatoPrediction";
import ApplePrediction from "./components/ApplePrediction";
import CherryPrediction from "./components/CherryPrediction";
import CornPrediction from "./components/CornPrediction";
import GrapePrediction from "./components/GrapePrediction";
import TomatoPrediction from "./components/TomatoPrediction";
import { PlantStressReport } from "./components/PlantStressReport";

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/PlantDiseaseDetection"
            element={<PlantDiseaseDetection />}
          />
          <Route path="/FertilizerReport" element={<FertilizerReport />} />
          <Route path="/WaterReport" element={<WaterReport />} />
          <Route path="/PlantStressReport" element={<PlantStressReport />} />
          <Route path="/AboutProject" element={<AboutProject />} />
          <Route path="/strawberry" element={<StrawberryPrediction />} />
          <Route path="/mango" element={<MangoPrediction />} />
          <Route path="/potato" element={<PotatoPrediction />} />
          <Route path="/apple" element={<ApplePrediction />} />
          <Route path="/cherry" element={<CherryPrediction />} />
          <Route path="/corn" element={<CornPrediction />} />
          <Route path="/grape" element={<GrapePrediction />} />
          <Route path="/tomato" element={<TomatoPrediction />} />
          <Route path="/PlantHealth" element={<PlantHealth />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
